/**
 * Convert customFields to lines
 * @param input input
 */
export function convertCustomFieldsToLines(input) {
    const customFields = [];
    input.forEach(
        ({ type, name, name_i18n, description, description_i18n, required, showInCatering }) => {
            customFields.push({
                id: `${Math.random()}`.substring(2),
                type,
                name,
                name_i18n,
                description,
                description_i18n,
                required,
                showInCatering,
            });
        },
    );
    return customFields;
}

/**
 * Convert lines to customFields
 * @param customFields customFields
 */
export function convertLinesToCustomFields(customFields) {
    const customFieldsValue = [];
    // remove id from customFields
    for (let i = 0; i < customFields.length; i++) {
        const { id: _id, ...rest } = customFields[i];
        customFieldsValue.push(rest);
    }
    return customFieldsValue;
}
